import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable, finalize } from 'rxjs';
import { Router } from '@angular/router';

import { User } from 'src/app/model/user';

@Injectable({ providedIn: 'root' })
export class AuthAdminGuard implements CanActivate {

  user: User;

  constructor(private router: Router) { }

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {

    //check if user is admin
    const sessionUser = sessionStorage.getItem("user");
    if (sessionUser !== null) {
      const user: User = JSON.parse(sessionUser);
      if (!user.isRoleAdmin) {
        console.log("user is not admin");
        this.router.navigate(['public/error']);
        return false;
      }
    }

    return true;
  }
}